import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "collection";

const initialState = {
  loading: null,
  collectionsList: [],
  collectionResponse: {},
  errorMessage: "",
};

//POST
export const addCollectionToServer = createAsyncThunk(
  `${namespace}/addCollectionToServer`,
  async (newCollection, { rejectWithValue }) => {
    try {
      const response = await api.post("/collection", newCollection, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getCollectionsFromServer = createAsyncThunk(
  `${namespace}/getCollectionsFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/collections", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });

      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getCollectionsFromServerByPagination = createAsyncThunk(
  `${namespace}/getCollectionsFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/collectionspagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getCollectionsCountFromServer = createAsyncThunk(
  `${namespace}/getCollectionsCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/collectionscountforsales", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// PATCH
export const updateCollectionInserver = createAsyncThunk(
  `${namespace}/updateCollectionInserver`,
  async (updatedCollection, { rejectWithValue }) => {
    try {
      const id = parseInt(updatedCollection.collectionId);
      const response = await api.patch(`/collection/${id}`, updatedCollection, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const collectionSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCollectionToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addCollectionToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.collectionResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(addCollectionToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getCollectionsFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getCollectionsFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.collectionsList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getCollectionsFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.collectionsList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(getCollectionsFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getCollectionsFromServerByPagination.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getCollectionsFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.collectionsList = [];
          state.errorMessage = error.message;
        }
      )
      .addCase(getCollectionsCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getCollectionsCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getCollectionsCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(updateCollectionInserver.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateCollectionInserver.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.collectionResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateCollectionInserver.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.collectionResponse = {};
        state.errorMessage = error.errorMessage;
      });
  },
});
export const selectLoadingStatus = (state) => state.collections.loading;
export default collectionSlice.reducer;
